export default (
  state = {
    isFetching: false,
    receivedAt: null,
    data: []
  },
  action,
) => {
  switch (action.type) {
    case 'REQUEST_TEACHING_CALENDARS':
      return {
        ...state,
        isFetching: true,
      }
    case 'RECEIVE_TEACHING_CALENDARS':
      return {
        ...state,
        isFetching: false,
        receivedAt: Date.now(),
        data: action.teachingCalendars,
      }
    default:
      return state
  }
}
